import { type Product } from '@/domain/Product';
import useTranslations from '@/widgets/hooks/useTranslations.tsx';
import type { Translations } from '@/widgets/ProductList/config/index.ts';
import AccessoryQuickViewContent from '../parts/AccessoryQuickViewContent/AccessoryQuickViewContent.tsx';
import QuickViewFooter from '../parts/QuickViewFooter/QuickViewFooter.tsx';
import ModalOnDemand from '@/widgets/components/controls/ModalOnDemand/ModalOnDemand.tsx';

export type AccessoryQuickViewDrawerProps = {
  product?: Product;
  isOpen: boolean;
  onClose: () => void;
  onGoToProductPage: (event: MouseEvent) => void;
};

export default function AccessoryQuickViewDrawer({
  product,
  isOpen,
  onClose,
  onGoToProductPage
}: AccessoryQuickViewDrawerProps) {
  if (!product) return null;

  const { t } = useTranslations<Translations>();
  const closeBtnA11yLabel = t('components.modal.closeBtnA11yLabel');

  return (
    <ModalOnDemand
      closeBtnA11yLabel={closeBtnA11yLabel}
      position="side"
      isOpen={isOpen}
      isMediaModal
      onClose={onClose}
      fixedFooter
      footerSlot={
        <QuickViewFooter
          product={product}
          onGoToProductPage={onGoToProductPage}
        />
      }
    >
      <AccessoryQuickViewContent product={product} />
    </ModalOnDemand>
  );
}
